'use client'
import { HeartIcon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartIconFill } from '@heroicons/react/24/solid';
import { use, useCallback, useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';
import { useAddToFavouritesMutation, useGetFavouriteListQuery, useRemoveFromFavouritesMutation } from 'lib/services/favourite';
import { useAuthentication } from 'hooks/useAuthentication';
import isEmpty from 'utilities/isEmpty';
import { useAuthWallFunction } from 'hooks/useAuthWallFunction';
import { alertSuccess } from 'components/controls/functions/alerts';
import FavouriteToggle from 'components/controls/favourites/FavouriteToggle';

export default function SpaceFavouriteToggle({ data }) {
    return <><FavouriteToggle data={data} render={(isFavourite, count, handleToggleIsFavourite) => {
        return <button className='btn btn-ghost hover:bg-transparent  btn-circle !right-[-1px] !top-[-3px] !px-[5px] !py-0  !absolute' onClick={handleToggleIsFavourite} aria-label="Add to favourites">
            {isFavourite ? <HeartIconFill
                strokeWidth={2}
                className="h-8 w-8  text-primary "
            /> : <HeartIcon
                strokeWidth={2}
                className="h-8 w-8 text-base-200 "
            />}
        </button>
    }} /></>
}